import axios from 'axios';
import Config from './Config';
import AccessToken from '../actions/AccessToken';
import Cookies from 'js-cookie'

const BASE_URL = Config();
// const token = AccessToken();
// let token = Cookies.get('access_token');

const getContact = {}
getContact.GetContactList = (endpoint, accessToken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
} 
getContact.AddContact = (data, endpoint, token, callback) => {
    axios({
        method: 'POST',
        data: data,
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${token}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}
getContact.ContactInfo = (endpoint, token, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${token}` },
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        // callback(error.response);
        console.log(error.response);
    })
}
getContact.Updatecontact = (data, endpoint, token, callback) => {
    axios({
        method: 'POST',
        data: data,
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${token}` },
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}
getContact.ContactForm = (endpoint, token, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${token}` },
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}
getContact.DeleteForm = (endpoint, token, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${token}` },
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}
getContact.DeleteContact = (endpoint, token, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${token}` },
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}
export default getContact;

